module.exports = __webpack_public_path__ + "img/cp_bcm01.169c26c2.png";